import { useState, useContext } from "react";

import { AuthContext } from "../../contexts/authContext";
import LoginForm, { SubmitLogin } from "../../components/loginForm";

import MedicAirLogo from "../../assets/MedicAirLogo";
import classes from "./index.module.scss";

const Login = () => {
  const { login } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>("");

  const handleSubmit = async ({ e, email, password }: SubmitLogin) => {
    e.preventDefault();
    setIsLoading(true);

    await login(email, password).then((res) => {
      console.log(res)
      if (res?.error) setErrMsg("Email or password are incorrect");

      setIsLoading(false);
    });

    setTimeout(() => setErrMsg(""), 2500);
  };

  return (
    <div
      style={{
        height: "100vh",
        flexDirection: "row",
        display: "flex",
      }}
    >
      <div className={classes.formContainer}>
        <div className={classes.logo}>
          <MedicAirLogo color="#fff" />
        </div>
        <LoginForm
          title="Welcome back!"
          subtitle="Login to your account"
          handleSubmit={handleSubmit}
          loading={isLoading}
          error={errMsg}
        />
      </div>
    </div>
  );
};

export default Login;
